export default async function getOffice({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'office');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
